export function bankAccountSetupError(err) {
  const message = err?.response?.data?.error?.message
  if (typeof message === 'string' && message.trim()) return message.trim()
  return 'Unable to open bank account setup. Try again.'
}
